import React from 'react';
import styled from 'styled-components';
import SidebarItem from '../SidebarItem';
import { SidebarContainer } from './styles.js';

function Sidebar({ interviews, currentInterviewId }) {
  return (
    <SidebarContainer>
      <img src="/images/recrutei-logo-hd.png" alt="Logomarca da Empresa" className="logo" />
      <h2>Últimas Entrevistas</h2>
      <ul className="interview-list">
        {interviews && interviews.length > 0 ? (
          interviews.map((interview) => (
            <SidebarItem
              key={interview._id}
              companyName={interview.company_name}
              vacancyTitle={interview.vacancy_title}
              talentUuid={interview.talent_uuid}
              applicationId={interview.application_id}
              selected={Number(interview.application_id) === Number(currentInterviewId)}
            />
          ))
        ) : (
          <li>Nenhuma entrevista encontrada</li>
        )}
      </ul>
    </SidebarContainer>
  );
}

export default Sidebar;
